import _moment from 'moment';
export const moment = _moment;
export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
export const MONTH_NAMES_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const DEFAULT_DATE_FORMAT: string = 'MM/DD/yyyy';
export const SERVICE_DATE_FORMAT = 'YYYY-MM-DD';
export const FULL_DATETIME_FORMAT = 'MM/DD/yyyy HH:mm';
export const BATCH_ID_DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
const format = (date: any, formatting?: string): string => {
  try {
    if (!date) {
      return '';
    }
    const m = moment(date);
    let formatDate = '';
    if (formatting) {
      formatDate = m.format(formatting);
    } else {
      formatDate = m.format(DEFAULT_DATE_FORMAT);
    }
    return formatDate;
  } catch {
    return '';
  }
};

// Returns the short month name of the provided full month
export const getShortMonthName = (fullMonth: string): string => {
  for (let i = 0; i < MONTH_NAMES_SHORT.length; i++) {
    if (fullMonth.startsWith(MONTH_NAMES_SHORT[i])) {
      return MONTH_NAMES_SHORT[i];
    }
  }
  return '';
};

// Returns the full month name of the provided short month
export const getFullMonthName = (shortMonth: string): string => {
  for (let i = 0; i < MONTH_NAMES.length; i++) {
    if (MONTH_NAMES[i].startsWith(shortMonth)) {
      return MONTH_NAMES[i];
    }
  }
  return '';
};

// Returns the month number based on month name
export const getMonthNumber = (
  monthName: string,
  isMonthNameShort: boolean
): number => {
  const monthArrToCheck = isMonthNameShort ? MONTH_NAMES_SHORT : MONTH_NAMES;
  for (let i = 0; i < monthArrToCheck.length; i++) {
    if (monthArrToCheck[i].startsWith(monthName)) {
      return i + 1;
    }
  }
  return 1;
};

// Returns the last N months based on month name
export const getLastNMonthsArrByMonthName = (
  monthName: string | null,
  offset: number,
  includeCurrentMonth?: boolean,
  returnFullMonthNames?: boolean,
  isProvidedMonthNameShort?: boolean
): Array<string> => {
  const today = new Date();
  // Determining which array to use - full/short
  const monthNamesArr: string[] = returnFullMonthNames
    ? MONTH_NAMES
    : MONTH_NAMES_SHORT;
  // Get the corresponding month number
  const monthNumToCalc = monthName
    ? getMonthNumber(monthName, !!isProvidedMonthNameShort) - 1
    : today.getMonth();
  // Convert the short month name to full if provided
  if (monthName && isProvidedMonthNameShort) {
    monthName = getFullMonthName(monthName);
  }
  const monthArr = [];
  let d;
  for (let i = offset; i > 0; i -= 1) {
    d = new Date(
      today.getFullYear(),
      monthNumToCalc - (includeCurrentMonth ? i - 1 : i),
      1
    );
    monthArr.push(monthNamesArr[d.getMonth()]);
  }
  return monthArr;
};

export const addDaysToDate = (date: any, days: number): any => {
  try {
    if (!date) {
      return '';
    }
    const m = moment(date);
    return moment(m).add('days', days);
  } catch {
    return '';
  }
};

export const appointmentsDateFormat = (date: any): string => {
  try {
    if (!date) {
      return '';
    }
    const m = moment(date);
    return moment(m).format('MM/DD/YYYY');
  } catch {
    return '';
  }
};

export const appointmentsTimeFormat = (date: any, zone: string): string => {
  try {
    if (!date) {
      return '';
    }
    const utc = moment(date).tz(zone).format(FULL_DATETIME_FORMAT);
    return moment(utc).format('LT');
  } catch {
    return '';
  }
};

export const DateFormatYYYYMMDD = (date: any): string => {
  try {
    if (!date) {
      return '';
    }
    return moment(date).format('YYYY-MM-DD');
  } catch {
    return '';
  }
};

export const appointmentsDateTimeFormat = (date: any, zone: string): string => {
  try {
    if (!date) {
      return '';
    }
    const utc = moment(date).tz(zone).format(FULL_DATETIME_FORMAT);
    const formatDate = moment(utc).format('L');
    const time = moment(utc).format('LT');
    return formatDate + ' ' + time;
  } catch {
    return '';
  }
};

export const appointmentsImportedDateFormat = (date: Date | string): string => {
  try {
    if (!date) {
      return '';
    }
    const formatDate = moment(date).format('L');
    const time = moment(date).format('LT');
    return time + ' ' + formatDate;
  } catch {
    return '';
  }
};

export const copayDateTimeFormat = (date: any): string => {
  try {
    if (!date) {
      return '';
    }
    const formatDate = moment(date).format('L');
    const time = moment(date).format('LT');
    return formatDate + ' ' + time;
  } catch {
    return '';
  }
};

// To return the appointment time
export const appointmentsTime = (date: any, zone: string): string => {
  try {
    if (!date) {
      return '';
    }

    // Format datetime in the specified timezone
    const utc = moment(date).tz(zone).format('YYYY-MM-DD HH:mm:ss');

    // Extract time in AM/PM format
    const time = moment(utc).format('LT');

    return time; // Return only the time portion (10:15 AM)
  } catch {
    return '';
  }
};

export default {format, DEFAULT_DATE_FORMAT};
